import { BLOCKS, Document } from '@contentful/rich-text-types';
import { getContentful } from '@/utilities/contentful';
import type { QueryFunctionContext } from '@tanstack/react-query';

interface PodcastsResponse {
  title: string;
  description: Document;
  podcastUrl: string;
}

interface Response {
  podcasts: PodcastsResponse[];
  totalPages: number;
}

export const getDefaultPodcasts = (): Response => ({
  totalPages: 0,
  podcasts: [
    {
      title: '',
      description: { nodeType: BLOCKS.DOCUMENT, content: [], data: {} },
      podcastUrl: '',
    },
  ],
});

const PAGE_SIZE = 12;

export const getPodcasts = async ({
  queryKey: [_key, page],
}: QueryFunctionContext<[string, number]>): Promise<void | Response> => {
  const client = getContentful();
  const response = client
    .getEntries<PodcastsResponse>({
      content_type: 'podcast',
      limit: PAGE_SIZE,
      skip: (page - 1) * PAGE_SIZE,
      order: '-sys.createdAt',
    })
    .then((entries) => {
      const totalPages = Math.ceil((entries.total || 0) / PAGE_SIZE);
      const podcasts = entries.items.map((entry) => {
        const fields = entry.fields;
        return {
          title: fields.title,
          description: fields.description,
          podcastUrl: fields.podcastUrl,
        };
      });

      return {
        totalPages,
        podcasts,
      };
    })
    .catch((err) => {
      console.error('Getting podcast data error', err);
    });
  return response;
};
